function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_169",
  "data-name": "Group 169",
  transform: "translate(-152.608 -4194.319)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_228",
  "data-name": "Path 228",
  d: "M240.136,4309.747q25,0,41.659-11.117t16.675-27.578q0-16.9-17.051-28.247t-42.046-11.341a94.992,94.992,0,0,0-15.122,1.189l4.914-38.334-33.937,30.892L173.217,4211.4v38.426l-13.808,6.68,12.985,13.4-19.786,30.623,33.627-13.546a39,39,0,0,0,11.856,11.862Q214.366,4309.757,240.136,4309.747ZM187.865,4279.8l-19.8,7.972,12.033-18.619-10.5-10.84,9.677-4.685v-31.271l16.626,10.435,25.154-22.9-3.08,24.021h0l-1.951,15.214,14.749,1.474-12.482,16.362,10.334,8.656-22.965,1.21-4.687,10.7Z",
  fill: "#b40000"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_229",
  "data-name": "Path 229",
  d: "M279.059,4467.942h-6.664q-5.922,0-5.919-15.513v-115.22q0-13.3-10.369-13.294l-18.141,1.85a71.328,71.328,0,0,1-13.7-.74q-10-1.11-13.7-1.11-16.663,0-16.667,22.216,0,19.994,12.589,19.993a20.837,20.837,0,0,0,4.078-.556,20.405,20.405,0,0,1,3.7-.557q4.812,0,4.812,15.442V4452.5q0,15.447-5.718,15.442h-7.25q-12.207,0-12.21,17.933,0,23.535,19.028,23.532a93.9,93.9,0,0,0,10.453-.444,202.935,202.935,0,0,1,23.124-1.775,113.8,113.8,0,0,1,13.246,1.113A114.976,114.976,0,0,0,273,4509.407q17.916,0,17.91-23.692Q290.908,4467.942,279.059,4467.942Z",
  fill: "#b40000"
}));

var SvgTransparentLogo = function SvgTransparentLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145.862,
    height: 315.088,
    viewBox: "0 0 145.862 315.088",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransparentLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transparent-logo.bc77ff92.svg";
export { ForwardRef as ReactComponent };